export function AppFooter() {
  return (
    <footer className="footer mt-auto py-3 bg-white text-center">
      <div className="container">
        <span className="text-muted">
          Copyright © {new Date().getFullYear()} Job Portal. All rights reserved.
        </span>
      </div>
    </footer>
  )
}
